const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://m9a2eagaeh.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_API_URL: 'https://bj4n1p16l1.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'taxonomy-company-1.13.1',
    HOSTNAME: 'https://company.staging.datainsights.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.staging.datainsights.forwoodsafety.com',
    WEBSOCKET: 'wss://ageuaq1co8.execute-api.us-west-2.amazonaws.com/staging'
  },
};

export default config;